import React from 'react';
import DashboardsLandingPage from './DashboardsLandingPage';
import DashboardsPage from './DashboardsPage';
import DashboardViewPage from './DashboardViewPage';
// @ts-ignore
import { useDashboardTour } from '../../tours/useDashboardTour';
// @ts-ignore
import { TourEngine } from '../../tours/TourEngine.jsx';
import { useAuth } from '../../context/useAuth';

export default function DashboardsContainer({ dashboardEditorState, setDashboardEditorState, handleBack, setActivePage, ...pageProps }: any) {
    const { token, user } = useAuth();
    const { steps: tourSteps, run: tourRun, setRun: setTourRun, markSeen: markTourSeen, restartTour } = useDashboardTour(user?.id, token);

    let content;
    if (dashboardEditorState) {
        if (dashboardEditorState.mode === 'view') {
            content = <DashboardViewPage {...pageProps} dashboardId={dashboardEditorState.dashboardId} onBack={() => { setDashboardEditorState(null); setActivePage('dashboards'); }} onEdit={(id: string) => setDashboardEditorState({ mode: 'edit', dashboardId: id })} />;
        } else {
            content = <DashboardsPage {...pageProps} isEditMode={dashboardEditorState.mode === 'edit' || dashboardEditorState.mode === 'new'} isNewDashboard={dashboardEditorState.mode === 'new'} dashboardId={dashboardEditorState.dashboardId} onBack={() => { setDashboardEditorState(null); setActivePage('dashboards'); }} onSaveComplete={() => setDashboardEditorState(null)} onNewDashboardSaved={(id: string) => setDashboardEditorState({ mode: 'edit', dashboardId: id })} />;
        }
    } else {
        content = <DashboardsLandingPage 
            {...pageProps}
            onCreateNew={() => setDashboardEditorState({ mode: 'new' })} 
            onEdit={(id: string) => setDashboardEditorState({ mode: 'edit', dashboardId: id })} 
            onView={(id: string, dash: any) => setDashboardEditorState({ mode: 'view', dashboardId: id })} 
            onRestartTour={restartTour}
        />;
    }

    return (
        <>
            {content}
            <TourEngine
                steps={tourSteps}
                run={tourRun}
                setRun={setTourRun}
                markSeen={markTourSeen}
            />
        </>
    );
}
